<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/health/bloodPressure">혈압</router-link></li>
            <li class="tab-menu__item active"><router-link to="/kr/mypage/health/bloodSugar">혈당</router-link></li>
            <li class="tab-menu__item"><router-link to="/kr/mypage/health/bodyMass">체질량</router-link></li>
        </ul>
    </div>
    <div class="info">
        <div class="table-search">
            <VueDatePicker v-model="selectedDateRange" locale="ko"
            :enable-time-picker="false" :format="customFormat"
            :week-start="0" :day-class="getDayClass"
            :select-text="'선택'" :cancel-text="'취소'" placeholder="날짜를 선택하세요." />
            

            <TimePicker v-model="time" format="HH:mm" minute-step="1" is24 />
        </div>
        <ul class="blood-scheduler">
            <li class="blood-scheduler__item">
                <div class="blood-scheduler__con">
                    <div class="blood-scheduler__top">
                        <div class="blood-scheduler--img">
                            <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/mypage-main__item6-icon05.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/mypage-main__item6-icon05-brain.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/mypage-main__item6-icon05-mom.svg" class="" alt="">
                        </div>
                        <h3 class="title02">현재상태</h3>
                    </div>
                    <div class="blood-scheduler__input radio-wrap">
                        <label  >
                            <input type="radio" name="test01" id="test01" value="식전" v-model="mealTime">
                            <span  class="radio-btn"></span>
                            <p>식전</p>
                        </label>
                        <label  >
                            <input type="radio" name="test02" id="test02" value="식후" v-model="mealTime">
                            <span  class="radio-btn"></span>
                            <p>식후</p>
                        </label>
                    </div>
                </div>
            </li>
            <li class="blood-scheduler__item">
                <div class="blood-scheduler__con">
                    <div class="blood-scheduler__top">
                        <div class="blood-scheduler--img">
                            <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/mypage-main__item6-icon02.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/mypage-main__item6-icon02-brain.svg" class="" alt="">
                            <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/mypage-main__item6-icon02-mom.svg" class="" alt="">
                        </div>
                        <h3 class="title02">혈당수치</h3>
                    </div>
                    <div class="blood-scheduler__input">
                        <input type="text" v-model="bloodSugar" @input="validateInput">
                        <p class="title03">mm/dL</p>
                    </div>
                </div>
            </li>
        </ul>
        <div class="botton-wrap">
            <a href="javascript:;" class="main-button c-main" @click="calculateResult">측정하기</a>
        </div>
    </div>
    <div class="info" v-if="!result">
        <div class="text-box type3">
            <h3 class="title03">혈당 측정 방법</h3>
            <p class="bullet03">혈당 측당 전 채혈이 잘 되도록 충분한 손마사지를 해줍니다.</p>
            <p class="bullet03">검사 전 따뜻한 물로 손을 씻어줍니다.</p>
            <p class="bullet03">채혈할 손을 알코올로 소독 후 완전히 말린 후 혈당을 측정합니다.</p>
            <p class="bullet03">매번 채혈부위를 변경하여 채혈합니다.</p>
            <p class="bullet03">검사 결과가 정상보다 너무 낮게 나오면 다시 측정합니다.</p>
            <p class="bullet03">병원에서의 혈청 검사와 가정에서 혈당 검사는 약 12%정도 낮게 측정되며, 10~15% 오차가 발생할 수 있습니다.</p>
        </div>
    </div>

    <!-- 측정시 -->
    <div class="info" v-if="result">
        <div class="text-box type3">
            <div class="emphasis">
                <div class="emphasis--icon">
                    <span style="display: contents;" v-if="result == '정상'">
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-good.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-good-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-good-mom.svg" class="" alt="">
                    </span>
                    <span style="display: contents;" v-else>
                        <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="/resource/icon/emphasis-warning.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="/resource/icon/emphasis-warning-brain.svg" class="" alt="">
                        <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="/resource/icon/emphasis-warning-mom.svg" class="" alt="">
                    </span>
                </div>
                <h3 class="title01">현재 {{mealTime}} 혈당 상태는 <br class="show-mo"><span :class="result == '정상' ? 'c-blue' : 'c-red'">‘{{result}}’</span> 입니다.</h3>
            </div>
        </div>
    </div>
    <div class="info" v-if="result">
        <div class="table-wrap">
            <div class="table">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:33.33%;">
                            <col style="width:33.33%;">
                            <col style="width:33.33%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>혈당분류</th>
                                <th>식전혈당</th>
                                <th>식후혈당</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>저혈당</td>
                                <td>70mg/dL 미만</td>
                                <td>70mg/dL 미만</td>
                            </tr>
                            <tr>
                                <td>정상</td>
                                <td>70~100mg/dL</td>
                                <td>70~140mg/dL</td>
                            </tr>
                            <tr>
                                <td>조절필요</td>
                                <td>100~124mg/dL</td>
                                <td>140~200mg/dL</td>
                            </tr>
                            <tr>
                                <td>관리필요</td>
                                <td>125mg/dL 이상</td>
                                <td>200mg/dL 이상</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="botton-wrap" v-if="result">
            <a href="javascript:;" class="main-button c-main" @click="saveSubmit">결과저장</a>
        </div>
    </div>
    <kr_popup_health ref="MypagePopupVue"/>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import TimePicker from 'vue3-timepicker';
import 'vue3-timepicker/dist/VueTimepicker.css';
import { useRoute } from 'vue-router'

export default {
    components: {
        VueDatePicker,
        TimePicker,
    },
    data() {
        return {
            time: {HH: "", mm: ""},  // 시간 선택값을 저장
            selectedDateRange: new Date(), // 날짜 선택값
            customFormat: 'yyyy-MM-dd',  // 날짜 포맷
            formatDate: 'yyyy-MM-dd',  // 날짜 포맷

            result: '',
            bloodSugar: '',
            mealTime: '식전',
        };
    },
    watch: {
        mealTime() {
            if (this.result) {
                this.calculateResult()
            }
        }
    },
    methods: {
        validateInput(event) {
            const input = event.target.value.replace(/[^\d]/g, '').slice(0, 3)
            this.bloodSugar = input
        },
        calculateResult() {
            const bloodSugar = parseInt(this.bloodSugar)

            if (!this.bloodSugar) {
                alert("혈당 수치를 입력해 주세요")
                return
            }

            if (this.mealTime === '식전') {
                if (bloodSugar < 70) {
                    this.result = '저혈당'
                } else if (bloodSugar >= 70 && bloodSugar <= 100) {
                    this.result = '정상'
                } else if (bloodSugar > 100 && bloodSugar <= 124) {
                    this.result = '조절필요'
                } else if (bloodSugar >= 125) {
                    this.result = '관리필요'
                }
            } else if (this.mealTime === '식후') {
                if (bloodSugar < 70) {
                    this.result = '저혈당'
                } else if (bloodSugar >= 70 && bloodSugar <= 140) {
                    this.result = '정상'
                } else if (bloodSugar > 140 && bloodSugar <= 200) {
                    this.result = '조절필요'
                } else if (bloodSugar > 200) {
                    this.result = '관리필요'
                }
            }

            if(this.result){
                this.$nextTick(() => {
                    const el = document.querySelector('.text-box.type3')
                    const top = el.getBoundingClientRect().top;
                    const curY = window.pageYOffset
                    const header = document.querySelector('.header-bottom').clientHeight
                    const sum = top + curY - header
                    window.scrollTo({top: sum})
                });
            }
        },
        saveSubmit() {
            this.$refs.MypagePopupVue.popupBtn()
        },
        submit() {
            let reqData = {
                hmCd: 'BS'
            }

            var year = this.selectedDateRange.getFullYear()
            var month = ('0' + (this.selectedDateRange.getMonth() + 1)).slice(-2)
            var day = ('0' + this.selectedDateRange.getDate()).slice(-2)
            var hours = this.time.HH ? this.time.HH : ('0' + this.time.getHours()).slice(-2)
            var min = this.time.mm ? this.time.mm : ('0' + this.time.getMinutes()).slice(-2)

            reqData.logDt = year + '' + month + '' + day + '' + hours + '' + min + '00'
            reqData.record1 = this.mealTime
            reqData.record2 = this.bloodSugar
            reqData.record3 = ''
            reqData.result = this.result
            this.axios({
                method: "post",
                url: this.api.mypage.healthReg,
                params: reqData
            }).then(response => {
                alert('저장되었습니다.')
                this.bloodSugar = ''
                this.result = ''

                this.$router.push('/kr/mypage/health/bloodMain')
            })
        },
    },
    mounted() {
        const now = new Date();

        this.time.HH = now.getHours().toString().padStart(2, '0');
        this.time.mm = now.getMinutes().toString().padStart(2, '0');

        this.selectedDateRange = this.$store.state.reserveStore.bloodDate || now;

        // 테이블의 .table에 클릭 이벤트를 추가
        const tables = document.querySelectorAll('.table');

        tables.forEach((table) => {
            // .table 요소의 가상 요소 부분을 클릭한 것처럼 처리할 수 있게,
            // 테이블의 `::before`가 클릭될 수 있는 영역을 감싸는 영역을 클릭 이벤트로 처리
            table.addEventListener('click', () => {
                // 테이블에 'active' 클래스를 토글
                table.classList.add('active');
            });
        });
    },
    beforeUnmount() {
        if(!(useRoute().path == '/kr/mypage/health/bloodPressure'
            || useRoute().path == '/kr/mypage/health/bloodSugar'
            || useRoute().path == '/kr/mypage/health/bodyMass')) this.$store.commit('setBloodDate', '')
    },
}
</script>

<style scoped></style>